// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"a01ba71a","578":"35232675","598":"6e94814e","737":"50719b24","787":"7261a4b2","940":"b8c637fb","970":"d539f0a2"}[chunkId] + ".chunk.js";
};